const USER_MANAGEMENT_PERMISSION_KEY = 'userManagement';
const BUSINESS_GROUP_MANAGEMENT_PERMISSION_KEY = 'businessGroupManagement';
const FACILITY_MANAGEMENT_PERMISSION_KEY = 'facilityManagement';

export { USER_MANAGEMENT_PERMISSION_KEY, BUSINESS_GROUP_MANAGEMENT_PERMISSION_KEY, FACILITY_MANAGEMENT_PERMISSION_KEY };
